import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import * as React from "react";

const CustomAlertTriangleIcon: React.FC = () => {
    return (
        <StyledWrapper>
            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.7984 13.6602L10.2996 0.863281C9.72548 -0.121094 8.27669 -0.121094 7.69872 0.863281L0.203392 13.6602C-0.373523 14.641 0.345036 15.875 1.50136 15.875H16.499C17.6508 15.875 18.3715 14.6445 17.7984 13.6602ZM8.15504 4.90625C8.15504 4.44043 8.53298 4.0625 8.9988 4.0625C9.46462 4.0625 9.84255 4.44219 9.84255 4.90625V9.40625C9.84255 9.87207 9.46462 10.25 9.03044 10.25C8.59626 10.25 8.15504 9.87383 8.15504 9.40625V4.90625ZM8.9988 13.625C8.38848 13.625 7.89348 13.13 7.89348 12.5197C7.89348 11.9094 8.38813 11.4144 8.9988 11.4144C9.60946 11.4144 10.1041 11.9094 10.1041 12.5197C10.1027 13.1293 9.61052 13.625 8.9988 13.625Z"
                    fill="#ED0000"
                />
            </svg>
        </StyledWrapper>
    );
};

export default React.memo(CustomAlertTriangleIcon);
